import { useSyncExternalStore } from 'react';

import {
  listDiagnoses,
  loadDiagnoses,
  subscribeDiagnoses,
} from './diagnosisStore';

import type { DiagnosisRecord } from './toDiagnosisRecord';

/**
 * useDiagnoses — 저장된 회차를 최신순으로, **저장·삭제가 나면 다시 그린다**.
 *
 * `useState(loadDiagnoses)`(홈·이력·MY 의 예전 관례)는 화면을 연 순간 한 번만
 * 읽는다 — 복원(`restoreDiagnoses`)은 부팅 뒤 비동기로 끝나서, 그 관례로는 복원된 회차가
 * 화면에 뜨려면 새로고침이 필요했다. `diagnosisStore.subscribeDiagnoses`를
 * `useSyncExternalStore`로 구독해 이 문제를 없앤다.
 *
 * **snapshot은 인덱스가 실제로 바뀌었을 때만 다시 읽는다.** `loadDiagnoses()`는 회차마다
 * 개별 키를 읽어 배열을 새로 만드는데, 매 렌더 다시 부르면 매번 다른 배열 참조가 나와
 * `useSyncExternalStore`가 무한 렌더에 빠진다(경고가 아니라 실제로 멈춘다). 무효화 판단은
 * (알림 횟수가 아니라) **인덱스 내용의 서명**으로 한다 — `saveDiagnosis`/`clearDiagnoses`를
 * 거치지 않고 저장소가 지워지는 경로(테스트의 `localStorage.clear()` 등)에도 캐시가
 * 스스로 낡은 걸 알아챈다. 인덱스는 메타데이터만이라(파일 헤더 주석) 매 렌더 다시 읽어도
 * 회차 본문을 읽는 `loadDiagnoses()`보다 훨씬 싸다.
 */
let cachedSignature = '';
let cached: DiagnosisRecord[] = [];

const getSnapshot = (): DiagnosisRecord[] => {
  const signature = JSON.stringify(listDiagnoses());
  if (signature !== cachedSignature) {
    cached = loadDiagnoses();
    cachedSignature = signature;
  }
  return cached;
};

export const useDiagnoses = (): DiagnosisRecord[] =>
  useSyncExternalStore(subscribeDiagnoses, getSnapshot);
